<template>
  <div>
    <v-container grid-list-md text-xs-center>
      <v-layout row wrap class="mb-5">
        <v-flex xs12>
          <h2 class="mb-5">Welcome to the family</h2>
        </v-flex>
        <v-flex xs12>
          <div class="text-xs-center">
            <v-fade-transition>
              <tumi-avatar v-show="isReady"></tumi-avatar>
            </v-fade-transition>
          </div>
        </v-flex>
        <v-flex xs12 md8 offset-md2>
          <v-fade-transition>
            <div class="message-wrapper" v-show="isReady">
              <vue-typed-js v-if="showCapitecRCS"
                v-show="!error && displayButtons"
                :strings="[`Thanks, we may have just found what you’re looking. Here are your loan provider options below.<br/>Oh and you’ll also find a complementary credit score below.`]"
                :typeSpeed="15"
              >
                <p class="typing message"></p>
              </vue-typed-js>
              <vue-typed-js v-if="showCapitec"
                v-show="!error && displayButtons"
                :strings="[`Thanks, we may have just found what you’re looking. Here are your loan provider options below.<br/>Oh and you’ll also find a complementary credit score below.`]"
                :typeSpeed="15"
              >
                <p class="typing message"></p>
              </vue-typed-js>
              <vue-typed-js v-if="showFinChoice"
                v-show="!error && displayButtons"
                :strings="[`Thanks. Based on your info, we think Finchoice will be your best fit. Oh and you’ll also find a<br/>complementary credit score below.`]"
                :typeSpeed="15"
              >
                <p class="typing message"></p>
              </vue-typed-js>
              <p v-if="!displayButtons" class="message mb-0" v-html="callMessage"></p>
              <p
                v-show="error"
                v-html="errorMessage"
                class="message mb-0"
              >Oops it seems there’s a problem.
                <br>We have sent an email to our support team and they’ll be in touch shortly.
              </p>
            </div>
          </v-fade-transition>
        </v-flex>
      </v-layout>
      <v-fade-transition>
        <v-form ref="form" v-show="scoreReady" v-model="valid" lazy-validation class="white--text">
          <v-layout row wrap align-center justify-center>
            <v-flex xs12>
              <p class="mb-5"><span class="font-weight-bold">Loan Amount:</span> R{{ loanAmount }}</p>
            </v-flex>
            <v-flex v-if="showCapitec" xl6 lg6 md6 sm12 xs12>
              <CardInfo :properties="properties.capitec"></CardInfo>
            </v-flex>
            <v-flex v-if="showCapitecRCS" xl6 lg6 md6 sm12 xs12>
              <CardInfo :properties="properties.rcs"></CardInfo>
            </v-flex>
            <v-flex v-if="showFinChoice" xs12>
              <CardInfo :properties="properties.finchoice"></CardInfo>
            </v-flex>
            <hr class="my-5">
            <v-flex xs12>
              <h2 class="mb-5">View your Virgin Money Credit Score</h2>
            </v-flex>

            <v-flex xs12>
              <div class="credit-score-container">
                <span class="credit-score-band">{{creditBand}}</span>
                <span style="font-weight: bolder; font-size: 2rem">{{creditScore}}</span>
              </div>
              <h3 style="margin-top: 2rem">{{creditRating}}</h3>
            </v-flex>
            <v-flex xs12>
              <p>Please check your mail for an OTP to continue to the FREE credit report.</p>
            </v-flex>
            <v-btn href="https://mymoney.virginmoney.co.za/">View your FREE credit report</v-btn>
          </v-layout>
        </v-form>
      </v-fade-transition>
    </v-container>
  </div>
</template>

<script>
  import axios from 'axios'
  import store from '../store'
  import router from '../router'
  import CardInfo from '../components/CardInfo.vue'

  // helper to get a displayable message to the user
  function getErrorMessage(err) {
    console.log(err)
    let responseBody
    responseBody = err.response
    if (!responseBody) {
      responseBody = err
    } else {
      responseBody = err.response.data || responseBody
    }
    return responseBody.message || JSON.stringify(responseBody)
  }

  export default {
    name: 'complete',
    components: {
      CardInfo
    },
    data: () => ({
      properties: {
        capitec: {
          borrow: 'Borrow',
          repay: 'Repay',
          value_borrow: 'up to R250 000​',
          value_repay: 'up to 84 months​',
          initiation_fee: 'Initiation fee',
          value_initiation_fee: 'R75 to R1 050​',
          monthly_service_fee: 'Monthly service fee',
          value_monthly_service_fee: 'R60​',
          imageURL: '/img/capitec_logo.png',
          url: process.env.VUE_APP_CAPITEC_URL,
          show_call_back: true,
          lead_provider: 'Capitec',
          show_apply_online_button: false
        },
        rcs: {
          borrow: 'Borrow',
          repay: 'Repay',
          value_borrow: 'up to R250 000​',
          value_repay: 'up to 60 months​',
          initiation_fee: 'Initiation fee',
          value_initiation_fee: 'R800',
          monthly_service_fee: 'Monthly service fee',
          value_monthly_service_fee: 'R60​',
          imageURL: '/img/rcs_logo.png',
          url: process.env.VUE_APP_RCS_URL,
          show_call_back: false,
          lead_provider: 'RCS',
          show_apply_online_button: true
        },
        finchoice: {
          borrow: 'Borrow',
          repay: 'Repay',
          value_borrow: 'up to R40 000​',
          value_repay: 'up to 24 months​',
          initiation_fee: 'Initiation fee',
          value_initiation_fee: 'R165 to R1 050​',
          monthly_service_fee: 'Monthly service fee',
          value_monthly_service_fee: 'R60​',
          imageURL: '/img/finchoice_logo.png',
          url: process.env.VUE_APP_FINCHOICE_URL,
          show_call_back: false,
          lead_provider: 'Finchoice',
          show_apply_online_button: true
        }
      },
      valid: true,
      error: false,
      errorMessage: '',
      creditScoreLow: false,
      isReady: false,
      scoreReady: false,
      productReady: false,
      noThanksSubmitted: false,
      loanAmount: store.state.loanAmount,
      loanTerm: store.state.loanTerm,
      firstName: store.state.firstName,
      creditScore: store.state.creditScore,
      creditRating: '',
      creditBand: '',
      callback: null,
      displayButtons: true,
      callMessage: undefined,
      callbackRules: [v => !!v || 'Please choose an option'],
      alternateProviders: [],
      otherProviders: '',
      status: ''
    }),
    methods: {
      submit() {
        this.status = 'submitting'
        this.error = false
        axios
          .post(`${store.state.apiUrl}/auth/submit_lead`, {
            user_id: store.state.userId,
            submit_lead: true,
            alternate_providers: this.alternateProviders,
            other_providers: this.otherProviders
          })
          .then(() => {
            this.noThanksSubmitted = true
          })
          .catch(err => {
            this.$mixpanel.track(
              `Lead submission error - ${getErrorMessage(err)}`
            )
            this.errorMessage = getErrorMessage(err)
            this.error = true
            if (err.response.status === 500) {
              this.creditScoreLow = true
            }
          })
          .then(() => {
            this.status = ''
          })
      },
      onRefresh() {
        router.push({
          path: '/'
        })
      }
    },
    computed: {
      showCapitec() {
        // return this.creditScore >= 600 && this.loanAmount >= 20000
        return true
      },
      showCapitecRCS() {
        // return this.creditScore >= 600 && this.loanAmount >= 20000
        return false
      },
      showFinChoice() {
        return false
        // return this.creditScore < 600 || this.loanAmount < 20000
      }
    },
    mounted() {
      window.addEventListener('unload', this.onRefresh)
      setTimeout(() => {
        this.isReady = true
      }, 500)
      setTimeout(() => {
        this.scoreReady = true
      }, 1500)
      setTimeout(() => {
        this.productReady = true
      }, 3000)

      this.submit()

      if (this.creditScore >= 673) {
        this.creditRating = 'MINIMUM RISK'
        this.creditBand = 1
      } else if (this.creditScore <= 672 && this.creditScore >= 653) {
        this.creditRating = 'LOW RISK'
        this.creditBand = 2
      } else if (this.creditScore <= 652 && this.creditScore >= 636) {
        this.creditRating = 'AVERAGE RISK'
        this.creditBand = 3
      } else if (this.creditScore <= 635 && this.creditScore >= 623) {
        this.creditRating = 'HIGH RISK'
        this.creditBand = 4
      } else {
        this.creditRating = 'VERY HIGH RISK'
        this.creditBand = 5
      }

      // this.$mixpanel.track('Page: Complete')
    }
  }
</script>

<style lang="sass">
  .call-btn
    height: 100%
    padding: 0.5rem
    font-size: 0.9rem
    max-width: 180px

    &.call-now-btn
      background: #3ed29f !important
      color: #FFF !important

    &.call-later-btn
      color: #FFF !important
      border-width: 2px
      padding: calc(0.5rem - 2px)
      font-weight: normal !important

    .break-wrap
      display: flex
      flex-wrap: nowrap
      justify-content: center

      > *
        flex: 1

    .message-wrapper
      p
        a
          color: #21cc94 !important

  .score-pill
    background: transparent
    border: 3px solid #fff
    border-radius: 50%
    color: #fff
    width: 200px
    height: 200px
    display: inline-block
    position: relative

    .score
      line-height: 200px
      font-size: 3.5em
      font-weight: bold

    .highlight
      position: absolute
      top: 28px
      right: 0
      color: #428cb3
      background-color: white
      border-radius: 50%
      text-align: center
      width: 30px
      height: 30px
      line-height: 30px
      font-weight: 900


  .credit-score-container
    display: inline-flex
    justify-content: center
    align-items: center
    position: relative
    width: 50vw
    height: 50vw
    max-height: 200px
    max-width: 200px
    border: 2px solid #fff
    border-radius: 50%


    .credit-score-band
      position: absolute
      top: calc(14.64466095% - 0.75rem)
      right: calc(14.64466095% - 0.75rem)
      background: #FFF
      border-radius: 1rem
      width: 1.5rem
      height: 1.5rem
      color: #ff1001
      font-weight: bolder
      font-size: 1rem
      line-height: 1.5rem
</style>
